import React from 'react';
import { TableHeader, TableHead, TableRow } from '../../../ui/table';
import { Checkbox } from '../../../ui/checkbox';

type Props = {
  sortBy: 'severity_score' | 'received_at' | 'customer_name' | 'created_at' | 'complaint_detected' | 'vulnerability_detected';
  sortOrder: 'asc' | 'desc';
  onSort: (field: Props['sortBy']) => void;
  allSelected: boolean;
  onToggleAll: (checked: boolean) => void;
  col: { select: string; severity: string; date: string; customer: string; summary: string; taxonomyVersion: string; complaint: string; vulnerability: string; chevron: string };
  visibleColumns?: Set<string>;
};

const SignalsTableHeader: React.FC<Props> = ({ sortBy, sortOrder, onSort, allSelected, onToggleAll, col, visibleColumns }) => {
  return (
    <div className="bg-[#F7F7F7] h-10 flex items-center px-6 border-b border-[#F4F4F4] text-[10px] font-semibold uppercase tracking-wider text-[rgba(38,38,40,0.6)]">
      <div className={`${col.select} flex items-center`}>
        <Checkbox
          checked={allSelected}
          onCheckedChange={(checked) => onToggleAll(!!checked)}
          aria-label="Select all on page"
        />
      </div>
      <div className={`${col.severity} cursor-pointer hover:text-[rgba(38,38,40,0.8)]`} onClick={() => onSort('severity_score')}>
        Severity {sortBy === 'severity_score' ? (sortOrder === 'desc' ? '▼' : '▲') : ''}
      </div>
      <div className={`${col.date} cursor-pointer hover:text-[rgba(38,38,40,0.8)]`} onClick={() => onSort('received_at')}>
        Date {sortBy === 'received_at' ? (sortOrder === 'desc' ? '▼' : '▲') : ''}
      </div>
      <div className={`${col.customer} cursor-pointer hover:text-[rgba(38,38,40,0.8)]`} onClick={() => onSort('customer_name')}>
        Customer Name {sortBy === 'customer_name' ? (sortOrder === 'desc' ? '▼' : '▲') : ''}
      </div>
      <div className={col.summary}>Summary</div>
      {(!visibleColumns || visibleColumns.has('taxonomyVersion')) && (
        <div className={col.taxonomyVersion}>Version</div>
      )}
      <div className={`${col.complaint} cursor-pointer hover:text-[rgba(38,38,40,0.8)]`} onClick={() => onSort('complaint_detected')}>
        Complaint {sortBy === 'complaint_detected' ? (sortOrder === 'desc' ? '▼' : '▲') : ''}
      </div>
      <div className={`${col.vulnerability} cursor-pointer hover:text-[rgba(38,38,40,0.8)]`} onClick={() => onSort('vulnerability_detected')}>
        Vulnerability {sortBy === 'vulnerability_detected' ? (sortOrder === 'desc' ? '▼' : '▲') : ''}
      </div>
      <div className={col.chevron} />
    </div>
  );
};

export default React.memo(SignalsTableHeader);
